import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.528a2 2 0 0 0-.211-.894l-3.236-6.472A2 2 0 0 0 16.763 4H7.237a2 2 0 0 0-1.789 1.106l-3.236 6.472a2 2 0 0 0-.211.894zM7 6l-3 6h2.882c.685 0 1.312.387 1.618 1s.933 1 1.618 1h3.764c.685 0 1.312-.387 1.618-1s.933-1 1.618-1H20l-3-6z",
      clipRule: "evenodd"
    }
  )
);
var SvgInboxFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InboxFilled_default = SvgInboxFilled;

export { InboxFilled_default as default };
